import { render, staticRenderFns } from "./Cost.vue?vue&type=template&id=1ed86685&scoped=true"
import script from "./Cost.vue?vue&type=script&lang=js"
export * from "./Cost.vue?vue&type=script&lang=js"
import style0 from "./Cost.vue?vue&type=style&index=0&id=1ed86685&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed86685",
  null
  
)

export default component.exports